import React from 'react'

/**
 * Simple white card container used across the mobile pages,
 * matching the rounded/shadow style from the design.
 */
const MobileCard = ({ children, className = '', noPadding = false }) => {
   return (
      <div
         className={`bg-white rounded-lg shadow-sm ${
            noPadding ? '' : 'p-4 md:p-5'
         } ${className}`}>
         {children}
      </div>
   )
}

export default MobileCard
